import { CopyOutlined, CheckOutlined } from '@ant-design/icons';
import { InfoItemWithCopyProps } from './types';
import * as S from './styles';

export default function InfoItemWithCopy({
  label,
  value,
  fallback = 'Não informado',
  inline = false,
  removeColon = false,
}: InfoItemWithCopyProps) {
  const displayValue = value || fallback;
  const hasValue = Boolean(value);

  return (
    <S.InfoItem className="info-with-copy-container" $inline={inline}>
      <S.InfoLabel className="info-label" $inline={inline}>
        {label}
        {removeColon ? '' : ':'}
      </S.InfoLabel>
      <S.StyledText
        className="info-value"
        $inline={inline}
        copyable={
          hasValue
            ? {
                text: value,
                tooltips: ['Copiar', 'Copiado!'],
                icon: [<CopyOutlined />, <CheckOutlined />],
              }
            : false
        }
      >
        {displayValue}
      </S.StyledText>
    </S.InfoItem>
  );
}
